import { sectionHasStarted } from '@dosfilos/domain';

// ─── ¿Ya empezó la sección? — la misma regla que el servidor (H8) ──────────
// Para ANTICIPAR en la pantalla qué deja una baja: antes del inicio no queda
// rastro; desde el inicio queda W. Decide el servidor (`sectionHasStarted` en
// el dominio, con la zona del seminario); aquí solo se avisa antes de confirmar.

/** Timestamp de Firestore, Date, ISO o YYYY-MM-DD → Date a mediodía; si no, null. */
function toDate(v: unknown): Date | null {
  if (!v) return null;
  const maybe = (v as { toDate?: () => Date }).toDate?.();
  if (maybe instanceof Date) return maybe;
  if (v instanceof Date) return v;
  if (typeof v === 'string') {
    const d = /^\d{4}-\d{2}-\d{2}$/.test(v) ? new Date(`${v}T12:00:00`) : new Date(v);
    return isNaN(d.getTime()) ? null : d;
  }
  return null;
}

function ymd(d: Date): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function sectionStarted(
  section: { startDate?: unknown; lifecycleOverride?: unknown },
  /** El inicio del período (texto, Timestamp o Date), o nada. */
  termStart: unknown,
  todayYmd: string,
): boolean {
  const override = section.lifecycleOverride;
  const term = toDate(termStart);
  return sectionHasStarted({
    sectionStartDate: toDate(section.startDate),
    termStartYmd: term ? ymd(term) : null,
    lifecycleOverride: override === 'active' || override === 'concluded' ? override : null,
    todayYmd,
  });
}
